// extracted by mini-css-extract-plugin
module.exports = {"container":"Order_container__1FM7j","split":"Order_split__EV8X7","nextButton":"Order_nextButton__h041J"};